import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["label", "labelTooltip", "labelTooltipPlacement"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONTROL } from '../../../../components';
import { generateInstanceConfigItems, getDisk } from '../../../utils';
var ServerTypeItem = {
  ComputeIntensive: 'Compute-intensive',
  GeneralComputing: 'General computing',
  MemoryOptimized: 'Memory-optimized'
};
var serverTypeItems = [{
  value: ServerTypeItem.ComputeIntensive,
  label: 'Compute-intensive'
}, {
  value: ServerTypeItem.GeneralComputing,
  label: 'General computing'
}, {
  value: ServerTypeItem.MemoryOptimized,
  label: 'Memory-optimized'
}];
var InstanceConfigMap = _defineProperty(_defineProperty(_defineProperty({}, ServerTypeItem.ComputeIntensive, [[4, 8], [8, 16], [16, 32], [32, 64]]), ServerTypeItem.GeneralComputing, [[4, 16], [8, 32], [16, 64], [32, 128]]), ServerTypeItem.MemoryOptimized, [[4, 32], [8, 64], [16, 128]]);
var serverTypeInstanceConfigToEvsDiskSpaceMap = _defineProperty(_defineProperty(_defineProperty({}, ServerTypeItem.ComputeIntensive, {
  '4 8': [40, 1500],
  '8 16': [80, 1600],
  '16 32': [100, 3200],
  '32 64': [320, 10240]
}), ServerTypeItem.GeneralComputing, {
  '4 16': [40, 1600],
  '8 32': [80, 3200],
  '16 64': [100, 6400],
  '32 128': [100, 10240]
}), ServerTypeItem.MemoryOptimized, {
  '4 32': [40, 2560],
  '8 64': [80, 5120],
  '16 128': [160, 10240]
});
var baseInstanceConfigItems = generateInstanceConfigItems(InstanceConfigMap[ServerTypeItem.ComputeIntensive]);
function getAccessorKey(prefix) {
  return {
    serverType: "".concat(prefix, ".serverType"),
    instanceConfig: "".concat(prefix, ".instanceConfig"),
    evsDiskSpace: "".concat(prefix, ".evs.systemDisk.diskSpace"),
    evsDiskSpecification: "".concat(prefix, ".evs.systemDisk.specification"),
    nodeCount: "".concat(prefix, ".nodeCount")
  };
}
function getNodeConfigControls(_ref) {
  var prefix = _ref.prefix,
    diskProps = _ref.diskProps,
    nodeCountProps = _ref.nodeCountProps;
  var accessorKey = getAccessorKey(prefix);
  return {
    serverType: {
      type: CONTROL.SelectSingle,
      accessorKey: accessorKey.serverType,
      defaultValue: ServerTypeItem.ComputeIntensive,
      items: serverTypeItems,
      decoratorProps: {
        label: 'Тип сервера'
      }
    },
    instanceConfig: {
      type: CONTROL.SelectSingle,
      accessorKey: accessorKey.instanceConfig,
      defaultValue: baseInstanceConfigItems[0].value,
      items: baseInstanceConfigItems,
      decoratorProps: {
        label: 'Спецификация ноды'
      },
      watchedControls: {
        serverType: accessorKey.serverType
      },
      relateFn: function relateFn(_ref2) {
        var serverType = _ref2.serverType;
        return {
          items: generateInstanceConfigItems(InstanceConfigMap[serverType])
        };
      }
    },
    evs: getDisk({
      space: {
        accessorKey: accessorKey.evsDiskSpace,
        label: 'Объем системного диска',
        defaultValue: diskProps.defaultValue,
        uiProps: {
          min: diskProps.min,
          max: diskProps.max
        }
      },
      specification: {
        accessorKey: accessorKey.evsDiskSpecification,
        defaultValue: 'SSD'
      }
    }),
    nodeCount: {
      type: CONTROL.Stepper,
      accessorKey: accessorKey.nodeCount,
      defaultValue: nodeCountProps.defaultValue,
      decoratorProps: {
        label: 'Количество нод'
      },
      uiProps: {
        min: nodeCountProps.min,
        max: nodeCountProps.max,
        postfix: 'Шт'
      }
    }
  };
}
function getNodeConfig(props) {
  var _getNodeConfigControl = getNodeConfigControls(props),
    evs = _getNodeConfigControl.evs,
    serverType = _getNodeConfigControl.serverType,
    instanceConfig = _getNodeConfigControl.instanceConfig,
    nodeCount = _getNodeConfigControl.nodeCount;
  return {
    type: CONTROL.Object,
    ui: [['serverType', 'instanceConfig'], ['evs', 'nodeCount']],
    controls: {
      serverType: serverType,
      instanceConfig: instanceConfig,
      evs: evs,
      nodeCount: nodeCount
    }
  };
}
function getToggleNodeConfig(_ref3) {
  var label = _ref3.label,
    labelTooltip = _ref3.labelTooltip,
    labelTooltipPlacement = _ref3.labelTooltipPlacement,
    rest = _objectWithoutProperties(_ref3, _excluded);
  return {
    type: CONTROL.ToggleObject,
    decoratorProps: {
      label: label,
      labelTooltip: labelTooltip,
      labelTooltipPlacement: labelTooltipPlacement
    },
    switchKey: "".concat(rest.prefix, ".isIncluded"),
    control: getNodeConfig(rest)
  };
}
function getBaseNodeConfig(props) {
  var _getNodeConfigControl2 = getNodeConfigControls(props),
    serverType = _getNodeConfigControl2.serverType,
    instanceConfig = _getNodeConfigControl2.instanceConfig,
    nodeCount = _getNodeConfigControl2.nodeCount;
  var accessorKey = getAccessorKey(props.prefix);
  return {
    type: CONTROL.Object,
    ui: [['serverType', 'instanceConfig'], ['evs', 'nodeCount']],
    controls: {
      serverType: _objectSpread(_objectSpread({}, serverType), {}, {
        onChangeFn: function onChangeFn(value, setValue) {
          var arr = [[accessorKey.serverType, value]];
          var instanceConfigValue = generateInstanceConfigItems(InstanceConfigMap[value])[0].value;
          arr.push([accessorKey.instanceConfig, instanceConfigValue]);
          arr.push([accessorKey.evsDiskSpace, 40]);
          setValue(arr);
        }
      }),
      instanceConfig: _objectSpread(_objectSpread({}, instanceConfig), {}, {
        onChangeFn: function onChangeFn(value, setValue) {
          var arr = [[accessorKey.instanceConfig, value]];
          arr.push([accessorKey.evsDiskSpace, 40]);
          setValue(arr);
        }
      }),
      evs: getDisk({
        space: {
          accessorKey: accessorKey.evsDiskSpace,
          label: 'Объем системного диска',
          defaultValue: props.diskProps.defaultValue,
          uiProps: {
            min: props.diskProps.min,
            max: props.diskProps.max
          },
          watchedControls: {
            serverType: accessorKey.serverType,
            instanceConfig: accessorKey.instanceConfig
          },
          relateFn: function relateFn(_ref4) {
            var _serverTypeInstanceCo2;
            var serverType = _ref4.serverType,
              instanceConfig = _ref4.instanceConfig;
            var _ref5 = (serverTypeInstanceConfigToEvsDiskSpaceMap === null || serverTypeInstanceConfigToEvsDiskSpaceMap === void 0 ? void 0 : (_serverTypeInstanceCo2 = serverTypeInstanceConfigToEvsDiskSpaceMap[serverType]) === null || _serverTypeInstanceCo2 === void 0 ? void 0 : _serverTypeInstanceCo2[instanceConfig]) || [],
              _ref6 = _slicedToArray(_ref5, 2),
              min = _ref6[0],
              max = _ref6[1];
            if (min || max) {
              return {
                uiProps: {
                  min: min,
                  max: max
                }
              };
            }
          }
        },
        specification: {
          accessorKey: accessorKey.evsDiskSpecification,
          defaultValue: 'SSD'
        }
      }),
      nodeCount: nodeCount
    }
  };
}
export var ELASTIC_SEARCH_FORM_CONFIG = {
  ui: ['baseNodeConfig', 'masterNodeConfig', 'clientNodeConfig', 'coldDataNodeConfig', 'internet'],
  controls: {
    baseNodeConfig: getBaseNodeConfig({
      prefix: 'baseNodeConfig',
      diskProps: {
        defaultValue: 40,
        min: 40,
        max: 1500
      },
      nodeCountProps: {
        defaultValue: 1,
        min: 1,
        max: 200
      }
    }),
    masterNodeConfig: getToggleNodeConfig({
      label: 'Master node',
      labelTooltip: 'Мастер-узел, который управляет всеми узлами в кластере. Если для хранения и обработки данных требуется 20 или более узлов, рекомендуется включить мастер-узел, чтобы обеспечить стабильную работу кластера',
      prefix: 'masterNodeConfig',
      diskProps: {
        defaultValue: 40,
        min: 40,
        max: 40
      },
      nodeCountProps: {
        defaultValue: 3,
        min: 3,
        max: 9
      }
    }),
    clientNodeConfig: getToggleNodeConfig({
      label: 'Client node',
      labelTooltip: 'Клиент-узел, который позволяет клиентам получать доступ к кластерам и анализировать данные. Если для хранения и обработки данных требуется 20 или более узлов, рекомендуется включить клиент-узел, чтобы обеспечить стабильную работу кластера',
      prefix: 'clientNodeConfig',
      diskProps: {
        defaultValue: 40,
        min: 40,
        max: 40
      },
      nodeCountProps: {
        defaultValue: 1,
        min: 1,
        max: 32
      }
    }),
    coldDataNodeConfig: getToggleNodeConfig({
      label: 'Cold data node',
      labelTooltip: 'Холодный узел, который используется для хранения архивных данных. Если быстрый ответ (получение данных из холодного узла занимает несколько минут) не требуется, используйте узлы данного типа',
      prefix: 'coldDataNodeConfig',
      diskProps: {
        defaultValue: 40,
        min: 40,
        max: 1500
      },
      nodeCountProps: {
        defaultValue: 1,
        min: 1,
        max: 32
      }
    }),
    internet: {
      type: CONTROL.ToggleObject,
      switchKey: 'internet.isIncluded',
      decoratorProps: {
        label: 'Доступ в интернет'
      },
      control: {
        type: CONTROL.Object,
        ui: [['speed']],
        controls: {
          speed: {
            type: CONTROL.Stepper,
            accessorKey: 'internet.speed',
            defaultValue: 100,
            decoratorProps: {
              label: 'Скорость'
            },
            uiProps: {
              min: 1,
              max: 2000,
              postfix: 'Mбит/сек'
            }
          }
        }
      }
    }
  }
};